import { create } from 'zustand';

export const useBigdesMeasureStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    searchParams: {
        page: 1,
        pageSize: 20,
        sortBy: 'measure_code',
        sortOrder: 'asc',
        search: '',
    },
    paginationData: {
        total: 0,
        totalPages: 0,
        page: 1,
        pageSize: 20,
    },
    uniqueValues: {},

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setSearchParams: (params) => set((s) => ({
        searchParams: { ...s.searchParams, ...params },
    })),
    setPaginationData: (paginationData) => set({ paginationData }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues }),
}));
